import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";

// const experimentPhoneNumbers: Record<SegmentId, string> = {
//   a: "+1 888 978 3157",
//   b: "+1 888 978 5489"
// };

export const useOverridePhoneNumberInABTest = () => {
  const geolocation = useGeolocation();
  return geolocation?.phone;

  // const testContext = useExperimentTag("inbound-v2");

  // return match(testContext)
  //   .with({ segmentId: "a" }, () => experimentPhoneNumbers["a"])
  //   .with({ segmentId: "b" }, () => experimentPhoneNumbers["b"])
  //   .otherwise(() => geolocation?.phone);
};
